// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vr[data-v-ae564282]{border-right:1px solid #dde3e9}", "",{"version":3,"sources":["webpack://./bundles/Factory/CustomAdminBundle/public/vue/components/BoxEdit/WeightAndUnits.vue"],"names":[],"mappings":"AACI,qBACI,8BAAR","sourcesContent":["\n    .vr\n        border-right: 1px solid #DDE3E9\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
